export * from './app.component';
export * from './app.module';



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/index.ts